import { getHeadNetworks, getListOfNetworksId } from 'lib/marketplace-utils';
import * as yup from 'yup';
import { InferType } from 'yup';
import {
  VisibilityEnum as ApiVisibilityEnum,
  ListingOrgWritePublishActionEnum,
  ListingRead,
  ListingTypeEnum,
  PricePointEnum,
  ProductTypes,
  States,
} from '../../lib/api/generated';

export enum StockCategoryEnum {
  Breeding = 'Breeding',
  Trade = 'Trade',
  Store = 'Store',
  Stud = 'Stud',
}

export enum CattleGenderEnum {
  steers = 'Steers',
  heifers = 'Heifers',
  bulls = 'Bulls',
  mickes = 'Mickes',
  cows = 'Cows',
  cows_calves = 'Cows & calves',
}

export enum BreedEnum {
  purebred = 'Purebred',
  crossbred = 'Crossbred',
}

export enum PregnancyStatusEnum {
  pte = 'PTE',
  ptic = 'PTIC/PTIL',
  nsm = 'NSM',
  not_preg_tested = 'Not preg tested',
  unjoined = 'Unjoined',
}

export enum CattlePregnancyStatusEnum {
  pte = 'PTE',
  ptic = 'PTIC',
  station_mated = 'Station mated',
  nsm_unjoined = 'NSM/Unjoined',
}

export enum SheepPregnancyStatusEnum {
  pte = 'PTE',
  sil = 'SIL',
  station_mated = 'Station mated',
  nsm_unjoined = 'NSM/Unjoined',
}

export enum YesNoEnum {
  true = 'Yes',
  false = 'No',
}

export enum PriceEnum {
  fixed = 'fixed',
  negotiable = 'negotiable',
  poa = 'poa',
  range = 'range',
}

export enum CattleAgeEnum {
  calves = 'Calves',
  vealers = 'Vealers',
  weaners = 'Weaners',
  yearlings = 'Yearlings',
  grown = 'Grown',
}

export enum CattleDentitionEnum {
  zero_tooth = '0 tooth',
  two_tooth = '2 tooth',
  four_tooth = '4 tooth',
  six_tooth = '6 tooth',
  eight_tooth = '8 tooth',
}

export enum FeedTypeEnum {
  mixed = 'Mixed',
  grass = 'Grass',
  grain = 'Grain',
  stubble = 'Stubble',
  pasture = 'Pasture',
  hay = 'Hay',
  pellets = 'Pellets',
}

export enum HornTypeEnum {
  horned = 'Horned',
  tipped = 'Tipped',
  incomplete_dehorned = 'Incomplete dehorned',
  scurs = 'Scurs',
  dehorned = 'Dehorned',
  disbudded = 'Disbudded',
  no_horns = 'No Horns',
}

export enum AgentEnum {
  agent = "I'm using an agent",
  is_agent = 'I am an agent',
  no = "I'm not using an agent",
}

export enum SheepTagsEnum {
  black = 'Black (2016)',
  white = 'White (2017)',
  orange = 'Orange (2018)',
  green = 'Green (2019)',
  purple = 'Purple (2020)',
  yellow = 'Yellow (2021)',
  red = 'Red (2022)',
  blue = 'Blue (2023)',
  black2024 = 'Black (2024)',
  white2025 = 'White (2025)',
}

export enum SheepAgeEnum {
  lambs = 'Lambs',
  hoggets = 'Hoggets',
  mutton = 'Mutton',
}

export enum SheepGenderEnum {
  ewes = 'Ewes',
  wethers = 'Wethers',
  rams = 'Rams',
}

export enum GoatGenderEnum {
  doe = 'Doe',
  wether = 'Wethers',
  buck = 'Buck',
}

export enum GoatAgeEnum {
  adult = 'Adult',
  buckling = 'Buckling',
  doeling = 'Doeling',
  kids = 'Kids',
}

export enum GoatStockTypeEnum {
  rangeland = 'Rangeland',
  farmland = 'Farmed',
}

export enum LambDropEnum {
  Jan = 'Jan',
  Feb = 'Feb',
  Mar = 'Mar',
  Apr = 'Apr',
  May = 'May',
  Jun = 'Jun',
  Jul = 'Jul',
  Aug = 'Aug',
  Sep = 'Sep',
  Oct = 'Oct',
  Nov = 'Nov',
  Dec = 'Dec',
}

export const shortMonths = [
  { month: 'Jan', index: 1 },
  { month: 'Feb', index: 2 },
  { month: 'Mar', index: 3 },
  { month: 'Apr', index: 4 },
  { month: 'May', index: 5 },
  { month: 'Jun', index: 6 },
  { month: 'Jul', index: 7 },
  { month: 'Aug', index: 8 },
  { month: 'Sep', index: 9 },
  { month: 'Oct', index: 10 },
  { month: 'Nov', index: 11 },
  { month: 'Dec', index: 12 },
];

export enum WoolFibreEnum {
  Jan = 'Jan',
  Feb = 'Feb',
  Mar = 'Mar',
  Apr = 'Apr',
  May = 'May',
  Jun = 'Jun',
  Jul = 'Jul',
  Aug = 'Aug',
  Sep = 'Sep',
  Oct = 'Oct',
  Nov = 'Nov',
  Dec = 'Dec',
  'NA / Unshorn' = 'NA / Unshorn',
}

export enum VisibilityEnum {
  PRIVATE = 'No',
  PUBLIC = 'Yes',
}

export enum WeaningDateEnum {
  Jan = 'Jan',
  Feb = 'Feb',
  Mar = 'Mar',
  Apr = 'Apr',
  May = 'May',
  Jun = 'Jun',
  Jul = 'Jul',
  Aug = 'Aug',
  Sep = 'Sep',
  Oct = 'Oct',
  Nov = 'Nov',
  Dec = 'Dec',
  unweaned = 'Unweaned',
}

export enum FatConditionEnum {
  low = 'Low FS-1 (0-2mm)',
  FS1 = 'FS-1 (3-5mm)',
  FS2 = 'FS-2 (6-10mm)',
  FS3 = 'FS-3 (11-15mm)',
  FS4 = 'FS-4 (16-20mm)',
  FS5 = 'FS-5 (21-25mm)',
}

export enum EnquiriesEnum {
  agents = 'Agents',
  vendors = 'Vendors',
  hobby_farmers = 'Hobby Farmers',
  no_hobby_farmers = 'No Hobby Farmers',
}

export enum PriceTypeEnum {
  LIVEWEIGHT = 'LIVEWEIGHT',
  HSCW = 'HSCW',
  PER_HEAD = 'PER_HEAD',
}

const priceFormDataValidation = yup.object().shape({
  pricing_option: yup
    .string()
    .required('Please select a price condition')
    .nullable(),
  price_type: yup
    .string()
    .oneOf(Object.values(PriceTypeEnum))
    .required()
    .typeError('Please select a price type'),
  price_point: yup
    .string()
    .oneOf(Object.values(PricePointEnum))
    .required()
    .typeError('Please select a price point'),
  price_amount: yup.mixed().when('pricing_option', {
    is: (pricing_option: PriceEnum) => {
      return pricing_option !== 'range';
    },
    then: yup
      .mixed()
      .transform((_, val) => (val ? parseFloat(val) : null))
      .test(
        'Currency format only',
        'Currency format only, max 2 decimal places. e.g 10.15',
        (number: any) => {
          if (number) {
            return /^\d+(\.\d{1,2})?$/.test(number);
          } else {
            return true;
          }
        }
      )
      .required('Please enter a price'),
  }),
  min: yup.mixed().when('pricing_option', {
    is: (pricing_option: PriceEnum) => {
      return pricing_option === 'range';
    },
    then: yup
      .number()
      .min(0, 'Min price must be greater than 0')
      .transform((_, val) => (val !== '' ? Number(val) : null))
      .required('Please enter min price')
      .nullable(),
  }),
  max: yup.mixed().when('pricing_option', {
    is: (pricing_option: PriceEnum) => {
      return pricing_option === 'range';
    },
    then: yup.number().when('min', {
      is: (val: any) => val !== null,
      then: yup
        .number()
        .transform((value) => {
          return isNaN(value) || value === null ? null : parseFloat(value);
        })
        .min(
          yup.ref('min'),
          'Max range price must be greater than or equal to Min price'
        )
        .required('Please enter max price')
        .nullable(),
      otherwise: yup
        .number()
        .transform((_, val) => (val !== '' ? Number(val) : null))
        .required('Please enter price')
        .nullable(),
    }),
  }),
});

export const marketplaceListingFormSchema = yup.object({
  type: yup
    .string()
    .oneOf(Object.values(ListingTypeEnum))
    .required('Please select one'),
  product_type: yup
    .mixed()
    .oneOf(['CT', 'SH', 'GT'])
    .required('Please select one of the product'),
  quantity_min: yup
    .mixed()
    .test(
      'is-valid-number',
      'Quantity must be a valid number',
      function (value) {
        if (value !== undefined && value !== null && value !== '') {
          const numValue = Number(value);
          if (isNaN(numValue) || numValue <= 0) {
            throw this.createError({
              message: 'Quantity must be a valid number and greater than 0',
            });
          }
        }
        return true;
      }
    )
    .nullable()
    .transform((_, val) => (val !== '' ? Number(val) : null))
    .test(
      'is-min-or-max-required',
      'Min or Max range quantity is required',
      function (value) {
        const quantityMax = this.resolve(yup.ref('quantity_max'));
        if (
          quantityMax === null ||
          quantityMax === undefined ||
          quantityMax === ''
        ) {
          if (value === null || value === undefined || value === '') {
            throw this.createError({
              message: 'Min or Max range quantity is required',
            });
          }
        }
        return true;
      }
    ),

  quantity_max: yup
    .number()
    .min(
      yup.ref('quantity_min'),
      'Max range quantity must be greater than or equal to Min quantity'
    )
    .nullable()
    .transform((_, val) => (val !== '' ? Number(val) : null)),

  availability_from: yup
    .date()
    .required('Please enter availability date')
    .nullable()
    .typeError('Availability from date must be a valid date')
    .transform((value, originalValue) => {
      if (originalValue === '') {
        return null;
      }
      return value;
    }),
  availability_to: yup
    .mixed()
    .nullable()
    .when('availability_from', (availability_from, schema) => {
      return availability_from
        ? schema.test({
            test: (availability_to: Date) =>
              !availability_to ||
              new Date(availability_to) >= new Date(availability_from),
            message: 'Availability to must be greater than start date',
          })
        : schema;
    }),
  stock_category: yup
    .array()
    .of(yup.string().oneOf(Object.values(StockCategoryEnum)))
    .nullable(),
  cattle_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattleGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),
  sheep_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),
  goat_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'GT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(GoatGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),
  cattle_pregnancy_status: yup.array().when('cattle_gender', {
    is: (status: CattleGenderEnum[]) =>
      status &&
      status.some((gender: any) =>
        ['Cows', 'Cows & calves', 'Heifers'].includes(gender)
      ),
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattlePregnancyStatusEnum)))
      .nullable(),
  }),
  sheep_pregnancy_status: yup.array().when('sheep_gender', {
    is: (status: any) =>
      status && status.some((gender: any) => ['Ewes'].includes(gender)),
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepPregnancyStatusEnum)))
      .nullable(),
  }),
  goat_pregnancy_status: yup.array().when('goat_gender', {
    is: (status: any) =>
      status && status.some((gender: any) => ['Doe'].includes(gender)),
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(PregnancyStatusEnum)))
      .nullable(),
  }),

  lamb_drop: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup.array().when('sheep_stock_ages', {
      is: (ages: SheepAgeEnum[]) =>
        ages &&
        ages.some((age: SheepAgeEnum) => ['Lambs', 'Hoggets'].includes(age)),
      then: yup
        .array()
        .of(yup.string().oneOf(Object.values(LambDropEnum)))
        .nullable(),
    }),
  }),
  cattle_weaning_date: yup
    .array()
    .when('cattle_stock_ages', {
      is: (ages: CattleAgeEnum[]) =>
        ages &&
        ages.some((age: CattleAgeEnum) =>
          ['Calves', 'Vealers', 'Weaners'].includes(age)
        ),
      then: yup
        .array()
        .of(yup.string().oneOf(Object.values(WeaningDateEnum)))
        .nullable(),
    })
    .nullable(),
  sheep_weaning_date: yup
    .array()
    .when('sheep_stock_ages', {
      is: (ages: SheepAgeEnum[]) =>
        ages && ages.some((age: SheepAgeEnum) => ['Lambs'].includes(age)),
      then: yup.array().nullable(),
    })
    .nullable(),
  goat_weaning_date: yup
    .array()
    .when('goat_stock_ages', {
      is: (ages: GoatAgeEnum[]) =>
        ages && ages.some((age: GoatAgeEnum) => ['Kids'].includes(age)),
      then: yup.array().nullable(),
    })
    .nullable(),
  dentition: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattleDentitionEnum)))
      .nullable(),
  }),
  breed: yup
    .string()
    .oneOf(Object.values(BreedEnum), 'Please select breed')
    .required('Select at least 1 breed')
    .nullable(),
  purebred_breed: yup.string().when('breed', {
    is: 'Purebred',
    then: yup
      .string()
      .required('Please enter breed description or requirements.')
      .strict(),
  }),
  mixed_breed: yup.string().when('breed', {
    is: 'Crossbred',
    then: yup
      .string()
      .required('Please enter breed description or requirements.')
      .strict(),
  }),

  weighed: yup.boolean().nullable(),
  last_weighed: yup.date().when('weighed', {
    is: true,
    then: yup
      .date()
      .max(new Date('2099/01/01'))
      .transform((value, originalValue) => {
        if (originalValue === '') {
          return null;
        }
        return value;
      })
      .required('Please enter a valid date'),
  }),
  weight_range_min: yup.number().when('weighed', {
    is: true,
    then: yup
      .number()
      .transform((value) => {
        return isNaN(value) ? null : parseFloat(value);
      })
      .nullable(),
  }),
  weight_range_avg: yup.number().when('weighed', {
    is: true,
    then: yup
      .number()
      .transform((value) => {
        return isNaN(value) ? null : parseFloat(value);
      })
      .nullable(),
  }),
  weight_range_max: yup.number().when('weighed', {
    is: true,
    then: yup
      .number()
      .transform((value) => {
        return isNaN(value) ? null : parseFloat(value);
      })
      .nullable(),
  }),

  enquiries: yup
    .array()
    .of(yup.string().oneOf(Object.values(EnquiriesEnum)))
    .nullable(),

  feed_type: yup
    .array()
    .of(yup.string().oneOf(Object.values(FeedTypeEnum)))
    .nullable(),
  num_days_grain: yup
    .number()
    .integer()
    .when('feed_type', {
      is: (feeds: FeedTypeEnum[]) =>
        feeds &&
        feeds.some((feed: FeedTypeEnum) => ['Grain', 'Pellets'].includes(feed)),
      then: yup
        .number()
        .integer()
        .required()
        .typeError('Please enter a number'),
    }),
  tags: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepTagsEnum)))
      .nullable(),
  }),
  stock_type: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'GT',
    then: yup // goat
      .array()
      .of(yup.string().oneOf(Object.values(GoatStockTypeEnum)))
      .nullable(),
  }),
  treatments: yup.boolean().nullable(),
  treatment_type: yup.string().when('treatments', {
    is: true,
    then: yup.string().required('Please add treatment details'),
  }),
  withholding: yup
    .boolean()
    .when('treatments', {
      is: true,
      then: yup.boolean().required('Please answer yes or no').nullable(),
      otherwise: yup.boolean().nullable(),
    })
    .nullable(),
  withholding_finish_date: yup.date().when('withholding', {
    is: true,
    then: yup.date().required().typeError('Please enter a valid date'),
  }),
  hgp_free: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
    otherwise: yup.boolean().nullable(),
  }),
  lifetime_traceable: yup.boolean().nullable(),
  vendor_bred: yup.boolean().nullable(),
  blue_tongue_free: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
    otherwise: yup.boolean().nullable(),
  }),
  tick_free_zone: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
    otherwise: yup.boolean().nullable(),
  }),
  lpa_accredited: yup.boolean().nullable(),
  antibiotic_free: yup.boolean().nullable(),
  organic: yup.boolean().nullable(),
  fit_to_load: yup.boolean().required('Please answer yes or no').nullable(),
  horns: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
    otherwise: yup.boolean().nullable(),
  }),
  horn_type: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.array().when('horns', {
      is: true,
      then: yup
        .array()
        .of(yup.string().oneOf(Object.values(HornTypeEnum)))
        .min(1, 'Select at least 1 horn description')

        .nullable(),
    }),
  }),
  horn_length: yup.number().when(['product_type', 'horns', 'horn_type'], {
    is: (product: ProductTypes, horns: boolean, horn_type: string[]) =>
      product === 'CT' &&
      horns === true &&
      horn_type &&
      horn_type.length === 1 &&
      horn_type &&
      horn_type.includes(HornTypeEnum.no_horns),
    then: yup
      .number()
      .transform((val, originalVal) => {
        const parsedValue = parseFloat(originalVal);
        return isNaN(parsedValue) ? null : parsedValue;
      })
      .nullable(),
    otherwise: yup
      .number()
      .transform((val, originalVal) => {
        const parsedValue = parseFloat(originalVal);
        return isNaN(parsedValue) ? null : parsedValue;
      })
      .typeError('Please add a valid number (cm)'),
  }),

  price: priceFormDataValidation,
  lice: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'SH' || product === 'GT',
    then: yup.boolean().nullable(),
  }),
  footrot: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'SH' || product === 'GT',
    then: yup.boolean().nullable(), //sheep and goat
  }),
  mulesed: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup.boolean().nullable(),
  }),
  delivery_arrangement: yup.boolean().nullable(),
  delivery_at_short_notice: yup.boolean().nullable(),
  anonymous: yup
    .boolean()
    .required('Please answer yes or no')
    .typeError('Please select a value')
    .nullable(),
  publish_action: yup
    .string()
    .oneOf(
      Object.values(ListingOrgWritePublishActionEnum),
      'Please select whether you want to make the listing public or not yet'
    )
    .required(
      'Please select whether you want to make the listing public or not yet'
    )
    .typeError(
      'Please select whether you want to make the listing public or not yet'
    )
    .nullable(),
  blemishes: yup.boolean().nullable(),

  blemishes_detail: yup.string().when('blemishes', {
    is: true,
    then: yup.string().required('Please enter a blemishes detail'),
  }),
  is_brokerage_fee_payable: yup
    .boolean()
    .required('Please answer yes or no')
    .typeError('Please select a value')
    .nullable(),
  payable_brokerage_fee: yup.number().when('is_brokerage_fee_payable', {
    is: 'true',
    then: yup
      .number()
      .required('Please enter brokerage fee')
      .typeError('Payable fee must be a number')
      .nullable(true)
      .moreThan(0)
      .transform((_, val) => (val !== '' ? Number(val) : null)),
  }),
  cattle_stock_ages: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattleAgeEnum)))
      .nullable(),
  }),

  goat_stock_ages: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'GT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(GoatAgeEnum)))
      .required('Please select age')
      .typeError('Select at least one age'),
  }),

  sheep_stock_ages: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepAgeEnum)))
      .required('Please select age')
      .typeError('Select at least one age'),
  }),

  agent: yup.string().nullable(),
  agent_name: yup.string().when('agent', {
    is: (agent: any) =>
      agent && [agent].some((help: any) => ['agent'].includes(help)),
    then: yup.string().required('Please enter the agent name').nullable(),
  }),
  agent_branch: yup.string().when('agent', {
    is: (agent: any) =>
      agent && [agent].some((help: any) => ['agent'].includes(help)),
    then: yup.string().required('Please enter the agent branch').nullable(),
  }),
  agent_agency: yup.string().when('agent', {
    is: (agent: any) =>
      agent && [agent].some((help: any) => ['agent'].includes(help)),
    then: yup.string().required('Please enter the agency name'),
  }),
  comments: yup.string(),
  listing_name: yup
    .string()
    .max(150, 'Listing title cannot exceed 150 characters.')
    .required('Please add a listing title'),
  listing_address: yup
    .object({
      id: yup.string().defined(),
      name: yup.string().defined(),
      address: yup.string().defined(),
      suburb: yup.string().defined(),
      state: yup.string().oneOf(Object.values(States)).defined(),
      postcode: yup.string().defined(),
      pic: yup.string().defined(),
    })
    .required('Please select an address'),
  networks: yup.array().of(yup.string()),
  head_networks: yup.array().of(yup.string()),
});

export const listingDefaultValues = {
  availability_from: new Date(),
  networks: [],
  head_networks: [],
  enquiries: [],
  stock_category: [],
  dentition: [],
  feed_type: [],
  tags: [],
  stock_type: [],
  expected_fat: [],
  lamb_drop: [],
  wool_fibre_length: [],
  cattle_weaning_date: '',
  sheep_weaning_date: '',
  goat_weaning_date: '',
  cattle_pregnancy_status: [],
  goat_pregnancy_status: [],
  sheep_pregnancy_status: [],
};

export const formatFormDataForListingAPI = (
  formData: InferType<typeof marketplaceListingFormSchema>,
  product: 'CT' | 'GT' | 'SH'
) => {
  // @ts-ignore
  delete formData.type;
  // @ts-ignore
  delete formData.listing_name;
  // @ts-ignore
  delete formData.product_type;
  // @ts-ignore
  delete formData.quantity_min;
  // @ts-ignore
  delete formData.quantity_max;
  // @ts-ignore
  delete formData.listing_address;
  // @ts-ignore
  delete formData.target_price;
  // @ts-ignore
  delete formData.price;
  // @ts-ignore
  delete formData.media;
  // @ts-ignore
  delete formData.publish_action;
  // @ts-ignore
  delete formData.networks;
  // @ts-ignore
  delete formData.anonymous;
  if (product === 'CT') {
    // @ts-ignore
    delete formData.tags;
    // @ts-ignore
    delete formData.expected_fat;
    // @ts-ignore
    delete formData.lamb_drop;
    // @ts-ignore
    delete formData.stock_type;
    // @ts-ignore
    delete formData.wool_fibre_length;
    // @ts-ignore
    delete formData.sheep_weaning_date;
    // @ts-ignore
    delete formData.goat_pregnancy_status;
    // @ts-ignore
    delete formData.sheep_pregnancy_status;
    // @ts-ignore
    delete formData.goat_weaning_date;
  }

  if (product === 'GT') {
    // @ts-ignore
    delete formData.tags;
    // @ts-ignore
    delete formData.dentition;
    // @ts-ignore
    delete formData.cattle_weaning_date;
    // @ts-ignore
    delete formData.cattle_pregnancy_status;
    // @ts-ignore
    delete formData.stock_type;
    // @ts-ignore
    delete formData.lamb_drop;
    // @ts-ignore
    delete formData.wool_fibre_length;
    // @ts-ignore
    delete formData.sheep_weaning_date;
    // @ts-ignore
    delete formData.sheep_pregnancy_status;
  }

  if (product === 'SH') {
    // @ts-ignore
    delete formData.dentition;
    // @ts-ignore
    delete formData.cattle_weaning_date;
    // @ts-ignore
    delete formData.cattle_pregnancy_status;
    // @ts-ignore
    delete formData.stock_type;
    // @ts-ignore
    delete formData.goat_pregnancy_status;
    // @ts-ignore
    delete formData.goat_weaning_date;
  }
  return formData;
};

export const marketplaceDraftListingFormSchema = yup.object({
  product_type: yup.mixed().required('Please select one of the product'),
  listing_name: yup.string().required('Please add a listing title'),
  quantity_min: yup
    .mixed()
    .test(
      'is-valid-number',
      'Quantity must be a valid number',
      function (value) {
        if (value !== undefined && value !== null && value !== '') {
          const numValue = Number(value);
          if (isNaN(numValue) || numValue <= 0) {
            throw this.createError({
              message: 'Quantity must be a valid number and greater than 0',
            });
          }
        }
        return true;
      }
    )
    .nullable()
    .transform((_, val) => (val !== '' ? Number(val) : null))
    .test('is-min-or-max-required', 'Quantity is required', function (value) {
      const quantityMax = this.resolve(yup.ref('quantity_max'));
      if (
        quantityMax === null ||
        quantityMax === undefined ||
        quantityMax === ''
      ) {
        if (value === null || value === undefined || value === '') {
          throw this.createError({
            message: 'Quantity is required',
          });
        }
      }
      return true;
    }),
  breed: yup
    .string()
    .oneOf(Object.values(BreedEnum), 'Please select breed')
    .required('Select at least 1 breed')
    .nullable(),
  purebred_breed: yup.string().when('breed', {
    is: 'Purebred',
    then: yup
      .string()
      .required('Please enter breed description or requirements.')
      .strict(),
  }),
  mixed_breed: yup.string().when('breed', {
    is: 'Crossbred',
    then: yup
      .string()
      .required('Please enter breed description or requirements.')
      .strict(),
  }),
  cattle_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattleGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),
  sheep_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),
  goat_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'GT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(GoatGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),
  price: priceFormDataValidation,
});

export function formatAPIDataForListingForm(listing: ListingRead) {
  // price_method is upper-case on the API; the form's pricing_option is lower-case.
  const priceMethod = listing?.price_method?.toLowerCase();
  const isAuction = priceMethod === 'auction';

  return {
    agent: listing?.form_data?.agent || undefined,
    agent_agency: listing?.form_data?.agent_agency || undefined,
    agent_branch: listing?.form_data?.agent_branch || undefined,
    agent_name: listing?.form_data?.agent_name || undefined,
    antibiotic_free: listing?.form_data?.antibiotic_free || undefined,
    // An auction stores its single date as both bounds of `date`, so it reads back off date_from.
    auction_date: (isAuction ? listing?.date_from : undefined) || undefined,
    availability_from:
      (!isAuction ? listing?.date_from : undefined) || undefined,
    availability_to: (!isAuction ? listing?.date_to : undefined) || undefined,
    blue_tongue_free: listing?.form_data?.blue_tongue_free || undefined,
    breed: listing?.form_data?.breed || '',
    cattle_gender: listing?.form_data?.cattle_gender || undefined,
    cattle_pregnancy_status:
      listing?.form_data?.cattle_pregnancy_status || undefined,
    cattle_stock_ages: listing?.form_data?.cattle_stock_ages || undefined,
    comments: listing?.form_data?.comments || undefined,
    dentition: listing?.form_data?.dentition || undefined,
    feed_type: listing?.form_data?.feed_type || undefined,
    fit_to_load: listing?.form_data?.fit_to_load || undefined,
    goat_gender: listing?.form_data?.goat_gender || undefined,
    goat_pregnancy_status:
      listing?.form_data?.goat_pregnancy_status || undefined,
    goat_stock_ages: listing?.form_data?.goat_stock_ages || undefined,
    hgp_free: listing?.form_data?.hgp_free || undefined,
    horn_type: listing?.form_data?.horn_type || undefined,
    horns: listing?.form_data?.horns || undefined,
    horn_length: listing?.form_data?.horn_length || undefined,
    last_weighed: listing?.form_data?.last_weighed || undefined,
    lifetime_traceable: listing?.form_data?.lifetime_traceable || undefined,
    listing_address: {
      ...listing?.listing_address,
      id: listing?.listing_address?.id || '',
      name: listing?.listing_address?.name || '',
      address: listing?.listing_address?.address || '',
      suburb: listing?.listing_address?.suburb || '',
      state: listing?.listing_address?.state || '',
      postcode: listing?.listing_address?.postcode || '',
      pic: listing?.listing_address?.pic || '',
    },
    listing_name: listing?.title || '',
    title: listing?.title || '',
    lpa_accredited: listing?.form_data?.lpa_accredited || undefined,

    mixed_breed: listing?.form_data?.mixed_breed || undefined,

    num_days_grain: listing?.form_data?.num_days_grain || undefined,
    organic: listing?.form_data?.organic || undefined,
    product_type: listing?.product,
    type: listing?.type,
    purebred_breed: listing?.form_data?.purebred_breed || undefined,
    quantity_min:
      listing?.quantity_min !== undefined && listing?.quantity_min !== null
        ? Number(listing?.quantity_min)
        : listing?.quantity_max !== undefined && listing?.quantity_max !== null
        ? Number(listing?.quantity_max)
        : undefined,
    price_type:
      listing?.form_data?.price_type ||
      (listing?.prices ? Object.keys(listing.prices)[0] : undefined),
    quantity_max: undefined,
    sheep_gender: listing?.form_data?.sheep_gender || undefined,
    sheep_pregnancy_status:
      listing?.form_data?.sheep_pregnancy_status || undefined,
    sheep_stock_ages: listing?.form_data?.sheep_stock_ages || undefined,
    stock_category: listing?.form_data?.stock_category || undefined,
    price: {
      pricing_option: priceMethod,
      price_type: Object.keys(listing.prices)[0],
      price_point: listing.form_data?.price_point || undefined,
      price_amount: listing.prices[Object.keys(listing.prices)[0]]?.min,
      min: listing.prices[Object.keys(listing.prices)[0]]?.min,
      max: listing.prices[Object.keys(listing.prices)[0]]?.max,
    },
    tick_free_zone: listing?.form_data?.tick_free_zone || undefined,
    treatment_type: listing?.form_data?.treatment_type || undefined,
    treatments: listing?.form_data?.treatments || undefined,
    vendor_bred: listing?.form_data?.vendor_bred || undefined,
    weaning_date: listing?.form_data?.weaning_date || undefined,
    weighed: listing?.form_data?.weighed || undefined,
    weight_expected_max: listing?.form_data?.weight_expected_max || undefined,
    weight_expected_min: listing?.form_data?.weight_expected_min || undefined,
    weight_expected_avg: listing?.form_data?.weight_expected_avg || undefined,
    weight_range_max: listing?.form_data?.weight_range_max || undefined,
    weight_range_min: listing?.form_data?.weight_range_min || undefined,
    weight_range_avg: listing?.form_data?.weight_range_avg || undefined,
    withholding: listing?.form_data?.withholding || undefined,
    withholding_finish_date:
      listing?.form_data?.withholding_finish_date || undefined,
    lamb_drop: listing?.form_data?.lamb_drop || undefined,
    cattle_weaning_date: listing?.form_data?.cattle_weaning_date || undefined,
    sheep_weaning_date: listing?.form_data?.sheep_weaning_date || undefined,
    goat_weaning_date: listing?.form_data?.goat_weaning_date || undefined,
    wool_fibre_length: listing?.form_data?.wool_fibre_length || undefined,
    tags: listing?.form_data?.tags || undefined,
    stock_type: listing?.form_data?.stock_type || undefined,
    lice: listing?.form_data?.lice || undefined,
    footrot: listing?.form_data?.footrot || undefined,
    media: listing?.media || undefined,
    expected_fat: listing?.form_data?.expected_fat || undefined,
    delivery_arrangement: listing?.form_data?.delivery_arrangement || undefined,
    delivery_at_short_notice:
      listing?.form_data?.delivery_at_short_notice || undefined,
    blemishes: listing?.form_data?.blemishes || undefined,
    blemishes_detail: listing?.form_data?.blemishes_detail || undefined,
    is_brokerage_fee_payable:
      listing?.form_data?.is_brokerage_fee_payable || undefined,
    mulesed: listing?.form_data?.mulesed || undefined,
    enquiries: listing?.form_data?.enquiries || undefined,
    anonymous: listing?.anonymous ? 'true' : 'false',
    publish_action: listing?.visibility || undefined,
    networks:
      listing?.form_data?.networks ||
      getListOfNetworksId(listing?.networks)?.filter(
        (id) =>
          !(
            getHeadNetworks(listing?.networks)?.map((n) => n.id) || []
          ).includes(id)
      ) ||
      [],
    head_networks:
      listing?.form_data?.head_networks ||
      getHeadNetworks(listing?.networks)?.map((n) => n.id) ||
      [],
    owner: listing?.creator?.user_id || undefined,
  };
}

export const stockBuyingFormSchema = yup.object({
  quantity_min: yup
    .mixed()
    .test(
      'is-valid-number',
      'Quantity must be a valid number',
      function (value) {
        if (value !== undefined && value !== null && value !== '') {
          const numValue = Number(value);
          if (isNaN(numValue) || numValue <= 0) {
            throw this.createError({
              message: 'Quantity must be a valid number and greater than 0',
            });
          }
        }
        return true;
      }
    )
    .nullable()
    .transform((_, val) => (val !== '' ? Number(val) : null))
    .test(
      'is-min-or-max-required',
      'Min or Max range quantity is required',
      function (value) {
        const quantityMax = this.resolve(yup.ref('quantity_max'));
        if (
          quantityMax === null ||
          quantityMax === undefined ||
          quantityMax === ''
        ) {
          if (value === null || value === undefined || value === '') {
            throw this.createError({
              message: 'Min or Max range quantity is required',
            });
          }
        }
        return true;
      }
    ),
  quantity_max: yup
    .number()
    .min(
      yup.ref('quantity_min'),
      'Max range quantity must be greater than or equal to Min quantity'
    )
    .nullable()
    .transform((_, val) => (val !== '' ? Number(val) : null)),
  availability_from: yup
    .date()
    .required('Please enter availability date')
    .nullable()
    .typeError('Availability from date must be a valid date')
    .transform((value, originalValue) => {
      if (originalValue === '') {
        return null;
      }
      return value;
    }),
  availability_to: yup
    .mixed()
    .nullable()
    .when('availability_from', (availability_from, schema) => {
      return availability_from
        ? schema.test({
            test: (availability_to: Date) =>
              !availability_to ||
              new Date(availability_to) >= new Date(availability_from),
            message: 'Availability to must be greater than start date',
          })
        : schema;
    }),
  stock_category: yup
    .array()

    .nullable(),
  cattle_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattleGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),
  cattle_pregnancy_status: yup.array().when('cattle_gender', {
    is: (status: CattleGenderEnum[]) =>
      status &&
      status.some((gender: any) =>
        ['Cows', 'Cows & calves', 'Heifers'].includes(gender)
      ),
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(PregnancyStatusEnum)))
      .nullable(),
  }),
  cattle_stock_ages: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattleAgeEnum)))
      .nullable(),
  }),

  goat_stock_ages: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'GT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(GoatAgeEnum)))
      .required('Please select age')
      .typeError('Select at least one age'),
  }),

  sheep_stock_ages: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepAgeEnum)))
      .required('Please select age')
      .typeError('Select at least one age'),
  }),

  cattle_weaning_date: yup
    .array()
    .when('cattle_stock_ages', {
      is: (ages: CattleAgeEnum[]) =>
        ages &&
        ages.some((age: CattleAgeEnum) =>
          ['Calves', 'Vealers', 'Weaners'].includes(age)
        ),
      then: yup
        .array()
        .of(yup.string().oneOf(Object.values(WeaningDateEnum)))
        .nullable(),
    })
    .nullable(),
  sheep_weaning_date: yup
    .array()
    .when('sheep_stock_ages', {
      is: (ages: SheepAgeEnum[]) =>
        ages && ages.some((age: SheepAgeEnum) => ['Lambs'].includes(age)),
      then: yup.array().nullable(),
    })
    .nullable(),
  goat_weaning_date: yup
    .array()
    .when('goat_stock_ages', {
      is: (ages: GoatAgeEnum[]) =>
        ages && ages.some((age: GoatAgeEnum) => ['Kids'].includes(age)),
      then: yup.array().nullable(),
    })
    .nullable(),
  dentition: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(CattleDentitionEnum)))
      .nullable(),
  }),
  breed: yup.string().nullable().required('Please select a breed '),
  purebred_breed: yup.string().when('breed', {
    is: 'Purebred',
    then: yup
      .string()
      .required('Please enter breed description or requirements.')
      .strict(),
  }),
  mixed_breed: yup.string().when('breed', {
    is: 'Crossbred',
    then: yup
      .string()
      .required('Please enter breed description or requirements.')
      .strict(),
  }),

  weight_expected_min: yup
    .mixed()
    .transform((value) => {
      return isNaN(value) ? null : parseFloat(value);
    })
    .nullable(),
  weight_expected_avg: yup
    .number()
    .transform((value) => {
      return isNaN(value) ? null : parseFloat(value);
    })
    .when('weight_expected_min', {
      is: (val: any) => !!val,
      then: (schema) => {
        return schema.min(
          yup.ref('weight_expected_min'),
          'Average expected weight must be greater than or equal to Min expected weight'
        );
      },
    })
    .nullable(),
  weight_expected_max: yup
    .number()
    .transform((value) => {
      return isNaN(value) ? null : parseFloat(value);
    })
    .when('weight_expected_min', {
      is: (val: any) => !!val,
      then: (schema) => {
        return schema.min(
          yup.ref('weight_expected_min'),
          'Maximum expected weight must be greater than or equal to Min expected weight'
        );
      },
    })
    .nullable(),
  feed_type: yup
    .array()
    .of(yup.string().oneOf(Object.values(FeedTypeEnum)))
    .nullable(),
  num_days_grain: yup
    .number()
    .integer()
    .when('feed_type', {
      is: (feeds: FeedTypeEnum[]) =>
        feeds &&
        feeds.some((feed: FeedTypeEnum) => ['Grain', 'Pellets'].includes(feed)),
      then: yup
        .number()
        .integer()
        .required()
        .typeError('Please enter a number'),
    }),
  treatments: yup.boolean().nullable(),
  treatment_type: yup.string().when('treatments', {
    is: true,
    then: yup.string().required('Please add treatment details'),
  }),
  withholding_finish_date: yup.date().when('withholding', {
    is: true,
    then: yup.date().required().typeError('Please enter a valid date'),
  }),
  hgp_free: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
  }),
  lifetime_traceable: yup.boolean().nullable(),
  vendor_bred: yup.boolean().nullable(),
  blue_tongue_free: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
  }),
  tick_free_zone: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
  }),
  lpa_accredited: yup.boolean().nullable(),
  antibiotic_free: yup.boolean().nullable(),
  organic: yup.boolean().nullable(),
  anonymous: yup
    .boolean()
    .required('Please answer yes or no')
    .typeError('Please select a value')
    .nullable(),
  horns: yup.boolean().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.boolean().nullable(),
  }),
  horn_type: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'CT',
    then: yup.array().when('horns', {
      is: true,
      then: yup
        .array()
        .of(yup.string().oneOf(Object.values(HornTypeEnum)))
        .min(1, 'Select at least 1 horn description')
        .required('Please add a horn description')
        .nullable(),
    }),
  }),
  horn_length: yup.number().when(['product_type', 'horns', 'horn_type'], {
    is: (product: ProductTypes, horns: boolean, horn_type: string[]) =>
      product === 'CT' &&
      horns === true &&
      horn_type &&
      horn_type.length === 1 &&
      horn_type &&
      horn_type.includes(HornTypeEnum.no_horns),
    then: yup
      .number()
      .transform((val, originalVal) => {
        const parsedValue = parseFloat(originalVal);
        return isNaN(parsedValue) ? null : parsedValue;
      })
      .nullable(),
    otherwise: yup
      .number()
      .transform((val, originalVal) => {
        const parsedValue = parseFloat(originalVal);
        return isNaN(parsedValue) ? null : parsedValue;
      })
      .typeError('Please add a valid number (cm)'),
  }),
  price: priceFormDataValidation,
  delivery_arrangement: yup.boolean().nullable(),
  delivery_at_short_notice: yup.boolean().nullable(),
  is_brokerage_fee_payable: yup
    .boolean()
    .required('Please answer yes or no')
    .typeError('Please select a value')
    .nullable(),
  agent: yup.string().nullable(),
  agent_name: yup.string().when('agent', {
    is: (agent: any) =>
      agent && [agent].some((help: any) => ['agent'].includes(help)),
    then: yup.string().required('Please enter the agent name').nullable(),
  }),
  agent_branch: yup.string().when('agent', {
    is: (agent: any) =>
      agent && [agent].some((help: any) => ['agent'].includes(help)),
    then: yup.string().required('Please enter the agent branch').nullable(),
  }),
  agent_agency: yup.string().when('agent', {
    is: (agent: any) =>
      agent && [agent].some((help: any) => ['agent'].includes(help)),
    then: yup.string().required('Please enter the agency name'),
  }),
  comments: yup.string(),
  listing_name: yup
    .string()
    .max(150, 'Listing title cannot exceed 150 characters.')
    .required('Please add a listing title'),
  listing_address: yup
    .object({
      id: yup.string().defined(),
      name: yup.string().defined(),
      address: yup.string().defined(),
      suburb: yup.string().defined(),
      state: yup.string().oneOf(Object.values(States)).defined(),
      postcode: yup.string().defined(),
      pic: yup.string().defined(),
    })
    .required('Please select an address'),

  /** Sheep */
  sheep_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),

  lamb_drop: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup.array().when('sheep_stock_ages', {
      is: (ages: SheepAgeEnum[]) =>
        ages &&
        ages.some((age: SheepAgeEnum) => ['Lambs', 'Hoggets'].includes(age)),
      then: yup
        .array()
        .of(yup.string().oneOf(Object.values(LambDropEnum)))
        .nullable(),
    }),
  }),
  tags: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'SH',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(SheepTagsEnum)))
      .nullable(),
  }),

  /** Goats */
  goat_gender: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'GT',
    then: yup
      .array()
      .of(yup.string().oneOf(Object.values(GoatGenderEnum)))
      .min(1, 'Select at least 1 gender')
      .required('Please add a gender')
      .typeError('Select at least 1 gender'),
  }),

  stock_type: yup.array().when('product_type', {
    is: (product: ProductTypes) => product === 'GT',
    then: yup // goat
      .array()
      .of(yup.string().oneOf(Object.values(GoatStockTypeEnum)))
      .nullable(),
  }),
  publish_action: yup
    .string()
    .oneOf(
      Object.values(ApiVisibilityEnum),
      'Please select whether you want to make the listing public or not yet'
    )
    .required(
      'Please select whether you want to make the listing public or not yet'
    )
    .typeError(
      'Please select whether you want to make the listing public or not yet'
    )
    .nullable(),
  networks: yup.array().of(yup.string()),
  head_networks: yup.array().of(yup.string()),
});
